import React from 'react';
import CreateOrEditManualRefund from './CreateOrEditManualRefund';
import { REFUND_MODAL_TYPE } from '@/utility';

const CreateRefund = () => {
  return (
    <div>
      <CreateOrEditManualRefund
        path='create-refund'
        refundModalType={REFUND_MODAL_TYPE.CREATE}
      />
    </div>
  );
};

export default CreateRefund;
